// Etiquetas de las acciones que registra el historial de umas en el backend
// (enum AccionHistorialUma).
const ACCIONES_HISTORIAL = {
  CREAR_BLOQUE: "Agregó un bloque",
  EDITAR_BLOQUE: "Editó un bloque",
  ELIMINAR_BLOQUE: "Eliminó un bloque",
  APAGAR_BLOQUE: "Apagó o encendió un bloque",
  EDITAR_UMA: "Editó la información de la lección",
};

export const getAccionLabel = (accion) => ACCIONES_HISTORIAL[accion] ?? accion;

// En el constructor una uma de tipo UMA se le dice "Lección" y a un Reactivo
// "Evaluación"; el tipo crudo solo vive en la base.
const TIPOS_LECCION = {
  UMA: "Lección",
  Reactivo: "Evaluación",
};

export const getTipoLeccionLabel = (umaTipo) => TIPOS_LECCION[umaTipo] ?? umaTipo;

// En una uma el identificador es `titulo` y el nombre de la lección es `descripcion`.
export const getNombreLeccion = (uma) =>
  [uma?.titulo, uma?.descripcion].filter((parte) => !!parte).join(" · ");

export const esMovimientoDeLeccion = (movimiento) =>
  movimiento?.accion === "EDITAR_UMA";

// En los movimientos de bloque el detalle es el tipo de bloque; en los de la
// lección, los campos que cambiaron.
export const getDetalleMovimiento = (movimiento) => {
  if (esMovimientoDeLeccion(movimiento)) {
    return (movimiento?.camposModificados ?? []).join(", ");
  }
  return movimiento?.tipoBloqueNombre ?? "";
};

// La posición la resuelve el backend contra el orden actual de la lección, así que
// sube sola si después le insertan bloques antes. Un bloque que ya se eliminó no
// tiene posición actual.
export const getPosicionMovimiento = (movimiento) => {
  if (esMovimientoDeLeccion(movimiento) || !movimiento?.umaBloque) return "";

  return movimiento?.posicionBloque
    ? `posición ${movimiento.posicionBloque}`
    : "ya no está en la lección";
};

export const getEtiquetaDetalle = (movimiento) =>
  esMovimientoDeLeccion(movimiento) ? "Campos modificados" : "Bloque";

export const getNombreUsuario = (usuario) => {
  const nombre = [
    usuario?.nombres,
    usuario?.primerApellido,
    usuario?.segundoApellido,
  ]
    .filter((parte) => !!parte)
    .join(" ");

  return nombre !== "" ? nombre : usuario?.correoElectronico ?? "Usuario no disponible";
};

export const formatFechaHora = (fechaISO) => {
  if (!fechaISO) return "-";

  return new Intl.DateTimeFormat("es-MX", {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(fechaISO));
};

export const formatFecha = (fechaISO) => {
  if (!fechaISO) return "-";

  return new Intl.DateTimeFormat("es-MX", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  }).format(new Date(fechaISO));
};

// El backend ya regresa los movimientos de la más reciente a la más vieja, pero
// se ordena también aquí para que la vista no dependa de eso.
export const ordenarPorFechaDesc = (lista, obtenerFecha) =>
  [...(lista ?? [])].sort(
    (a, b) => new Date(obtenerFecha(b)) - new Date(obtenerFecha(a))
  );
